import React, {useEffect, useState} from 'react';
import {NotificationManager} from "react-notifications";
import {useNavigate} from 'react-router-dom';
import {Scrollbars} from "react-custom-scrollbars-2";
import BoxplotChart from "../../../../Components/BoxplotChart";
import ReattemptQuizModal from "../ReattemptQuizModal";
import IReferInfo from "../iReferInfo";
import * as Apis from "Api";
import {startMainAndSubActivities} from "../../../../services/AuditDataLogger";
import QueryString from "query-string";

const QuizScore = ({attemptInfo}) => {
    const navigate = useNavigate();
    const [isEmptyTruth, setIsEmptyTruth] = useState(true);
    const [reattemptQuizPercent, setReattemptQuizPercent] = useState(null);

    useEffect(() => {
        Apis.getAttemptQuizAnswer(attemptInfo.id, attemptInfo.current_test_case_id, false).then((quizAnswer) => {
            let emptyTruth;
            if (Array.isArray(quizAnswer)) {
                emptyTruth = quizAnswer.some(v => !v.truthOptionId || v.truthOptionId.length === 0);
            } else if (Array.isArray(quizAnswer.value)) {
                emptyTruth = quizAnswer.value.some(v => !v.truth || v.truth.length === 0);
            } else {
                delete quizAnswer?.isFinished;
                emptyTruth = !Object.keys(quizAnswer).length;
            }
            setIsEmptyTruth(emptyTruth);
        }).catch((error) => {
            NotificationManager.error(error.response ? error.response.data.error.message : error.message);
        });
        if ( attemptInfo.complete && attemptInfo.scores.length > 0 ) {
            const percent = attemptInfo.scores[0]?.score === undefined ? 0 : attemptInfo.scores[0].score;
            const param = QueryString.parse(window.location.search);
            if (param && param.from === 'test' && percent < 75) {
                setReattemptQuizPercent(percent);
            }
        }
    }, []);

    const onRestartTest = () => {
        startMainAndSubActivities('Redo Test');
        Apis.attemptsStart(attemptInfo.test_set_id, undefined).then(resp => {
            let path = '/test-view/' + resp.test_set_id + '/' + resp.id + '/' + resp.current_test_case_id;
            navigate(path, {replace: true});
        });
    }

    const percent = attemptInfo.scores[0]?.score === undefined ? 0 : attemptInfo.scores[0].score;
    let description = attemptInfo?.test_sets?.test_set_discussion;

    if (!description || description.trim() === '') {
        description = (isEmptyTruth || attemptInfo.scores.length === 0 || !attemptInfo?.test_sets?.show_score) ?  'The Quiz you have just completed does not score results. Thank you!' : null;
    }

    return (
        <div className={'row'}>
            {(!(isEmptyTruth || attemptInfo.scores.length === 0) && attemptInfo?.test_sets?.show_score) && (
                <div className={'col-md-6 score-data-container'}>
                    <div className={'quiz-score-data'}>
                        <div className="circle-progress">
                            <svg viewBox="0 0 36 36">
                                <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
                                <path className="circle" stroke-dasharray={`${percent}, 100`} d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
                            </svg>
                        </div>
                        <div className={'quiz-progress-info'}>
                            <span className={'text-white fs-19'}>{percent} %</span>
                            <span className={'text-white fs-23 fw-bold'}>Correct</span>
                        </div>
                    </div>
                    <div className={'score-chart-container mt-4'}>
                        <BoxplotChart
                            title={'Results compared to'}
                            score_type={'Quiz Result'}
                            showUserSelect={true}
                            attempt_id={attemptInfo.id}
                            value={percent}
                        />
                    </div>
                </div>
            )}
            <div className={'col-md-6'}>
                <Scrollbars
                    style={{height: 480, marginBottom: 1}}
                >
                    <div className={'bg-gray p-4'} dangerouslySetInnerHTML={{__html: description}}/>
                    {
                        attemptInfo.test_sets.modalities.modality_type === 'quiz' && <IReferInfo presenterInfo={attemptInfo.test_sets.test_set_presenter_info}/>
                    }
                </Scrollbars>
            </div>
            {(!(isEmptyTruth || attemptInfo.scores.length === 0) && attemptInfo?.test_sets?.show_score) && (
                <ReattemptQuizModal
                    open={reattemptQuizPercent !== null}
                    score={reattemptQuizPercent}
                    onClose={() => setReattemptQuizPercent(null)}
                    onReattempt={() => onRestartTest()}
                />
            )}
        </div>
    )
}

export default QuizScore;